import { render, staticRenderFns } from "./QuestionExecute.vue?vue&type=template&id=52efc964"
import script from "./QuestionExecute.vue?vue&type=script&lang=js"
export * from "./QuestionExecute.vue?vue&type=script&lang=js"
import style0 from "./QuestionExecute.vue?vue&type=style&index=0&id=52efc964&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports